
import { IIdx, Idx } from "./IIdx";
import FinderInlineVue from "@/finder/FinderInline.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import Store from "@/store/Store";
import { MasterData } from "@/store/MasterData";
import FinderVue from "@/finder/Finder.vue";
import { ITree } from "@/tree/ITree";
import { IdxImporter } from "./IdxImporter";
import { ILbl } from "../lbl/ILbl";
import { IdxSvc } from "./IdxSvc";
import { TreeSvc } from "@/tree/TreeSvc";
import ButtonVue from "@/lib/Button.vue";
import { LblSvc } from "../lbl/LblSvc";
import DbgVue from "../Dbg.vue";
import  SearcherOrder from "../searcher/SearcherOrder.vue"
import  ZlecenieSelector from "./ZlecenieSelector.vue"
import { Finder } from "@/finder/IFinder";


@Component({ components: { FinderVue, ButtonVue, DbgVue, FinderInlineVue, SearcherOrder, ZlecenieSelector } })
export default class IdxVue extends Vue {
  @Prop(String) lbl_id!: String;
  lblSvc: LblSvc = new LblSvc();
  old_version=true
  masterData: MasterData | undefined;
  tree!: ITree | undefined;
  lbl!: ILbl | undefined;
  idx: IIdx | undefined = new Idx();
  key: number = 0;
  dbg_key = 0;
  treeSvc: TreeSvc = new TreeSvc();
  show_idx = false;
  zlecenia:any[] = []
  customers:any[]=[]
  key_klient_wzor=0
  numery_technologii:number[] = [1,2,3,4,5,6,7,8]
  simple_search=true


  async mounted() {

    console.log("mounted idx");
    bus.register("zlecenie_sql",this.zlecenie_sql)
    bus.register("klient_wzor_selected",this.klient_wzor_selected)

    bus.register("zlecenie_selected",this.zlecenie_selected)

    

    this.masterData = (await new Store().getStore()).masterData;
    const masterData: MasterData|undefined =  await (await new Store().getStore()).masterData;

    if (!masterData) return;
    this.customers     = masterData.customers


    console.log("masterData", this.masterData);
    this.lbl = await this.lblSvc.find_by_id(this.lbl_id);
   
    if (!this?.lbl?._id) {
       alert("Załóż najpierw etykietę w Graflow dla tej technologii")
      return;
    }

    try {
      this.tree = await this.treeSvc.find_by_id(this.lbl.tree_id);
    } catch (err) {
      if (!this.tree) return;
    }

    const ret = await new IdxSvc().find_by_id(this.lbl_id).catch((err) => console.log(err));

    if (ret) {
      this.idx = ret;
      if (!this.idx.klient_wzor) this.idx.klient_wzor=new Finder()
      if (!this.idx.nr_technologii_wzor) this.idx.nr_technologii_wzor=4//flekso
      /*
      if (this.idx.indeks_finder && this.idx.indeks_finder.data.data_indeks_etykiety) {
        this.simple_search = true;
      } else {
        this.simple_search = false;
      }
      */
      console.log(this.idx.indeks_finder.data);
    } else {
      this.idx!._id = this.lbl_id;
    }

    await this.fill_idx_from_graflow()

    this.key++;

    bus.register("wybierz_indeks_erp_z_findera", this.wybierz_indeks_erp_z_findera);
  }

  beforeDestroy() {
    bus.remove("indeks_selected", this.indeks_selected);
    bus.remove("zlecenie_sql",this.zlecenie_sql)
    bus.remove("klient_wzor_selected",this.klient_wzor_selected)
    bus.remove("wybierz_indeks_erp_z_findera", this.wybierz_indeks_erp_z_findera);
    bus.remove("zlecenie_selected",this.zlecenie_selected)
  }

  async zlecenie_sql(e:any) {
    const obj:any=e.detail;
    const sql:string = obj.sql
    const conditions:any[] = obj.conditions
    let zlecenia: any[] = await this.lblSvc.get_zlecenia(sql, conditions)
    this.zlecenia=zlecenia
  }

  async chg() {
    if (!this.idx) return;
    if (!this.lbl) return;

    this.idx._id = this.lbl_id;
    if (this.lbl) {
      this.idx.prj_id = this.lbl?.parent_id;
    }
    const obj = await new IdxSvc().update_idx(this.idx);

    if (obj && obj._id) this.idx._id = obj._id;
    await this.idx_changed(this.idx)


    
  }

  async idx_changed(idx:IIdx) {
    if (!this.lbl) return;
   

      const l:any=this.lbl
      
      console.log(idx._id)
      console.log(idx.nazwa_etykiety)
      console.log(idx.nr_indeksu)
      console.log(idx.nr_indeksu_wzor)
      console.log(idx.numer_indeksu_u_klienta)

      
      l.idx_id                     = idx._id
      l.idx_nazwa_etykiety         = idx.nazwa_etykiety
      l.idx_nr_indeksu_erp         = idx.nr_indeksu
      l.idx_nr_indeksu         = idx.nr_indeksu
      l.nr_indeksu_erp = idx.nr_indeksu;
      l.idx_nr_indeksu_wzor_erp    = idx.nr_indeksu_wzor
      l.idx_numer_indeksu_u_klienta= idx.numer_indeksu_u_klienta 
 
      l.version+=3
      const lbl:any = await new LblSvc().update(l);
      if (lbl) this.lbl = lbl
     
  }


  public async wybierz_indeks_erp_z_findera() {

    if (!this.idx) { alert("Problem z idx"); return; }


    const finder_saved = {... this.idx.indeks_finder};
    console.log("finder_saved",JSON.stringify(finder_saved))

    this.idx = new Idx();
    
    await this.fill_idx_from_graflow();
    this.idx.indeks_finder = finder_saved;
    console.log("finder_saved1",JSON.stringify(finder_saved))

    if (
      this.idx &&
      this.idx.indeks_finder &&
      this.idx.indeks_finder.data &&
      this.idx.indeks_finder.data.data_indeks_etykiety
    ) {
      const finder_saved = this.idx.indeks_finder;
      const indeks: IIdx | undefined = await new IdxSvc().get_by_wytwor_idm(
        this.idx.indeks_finder.data.data_indeks_etykiety
      );
      if (indeks) {
        //this.idx = indeks;
        //this.idx.indeks_finder = finder_saved;
        //this.idx._id = this.lbl_id;

        this.idx.nr_indeksu_wzor = this.idx.indeks_finder.data.data_indeks_etykiety;
        if (this.lbl) {
          this.lbl.nr_indeksu_wzor = this.idx.nr_indeksu_wzor;
        }
        await this.chg();
        this.$emit("idx_changed", this.idx);


        this.key++;
      }
    } else {
      console.log(this.idx)
      alert("Wybierz_indeks_erp_z_findera: Najpierw wybierz indeks ERP");
    }
  }


 public async wybierz_indeks_erp_ze_zlecenia(nr_indeksu:string) {
    if (!this.idx) return;
    
    this.idx.indeks_finder = new Finder()
    const finder_saved = this.idx.indeks_finder;
    this.idx = new Idx();
    await this.fill_idx_from_graflow();
    this.idx.indeks_finder = finder_saved;

    this.idx.nr_indeksu_wzor = nr_indeksu;

    if (this.lbl) {
          this.lbl.nr_indeksu = this.idx.nr_indeksu;
          this.lbl.nr_indeksu_wzor = this.idx.nr_indeksu_wzor;
          this.lbl.version++
          await new LblSvc().update(this.lbl);
          this.$emit("idx_changed", this.idx);
    }

    await this.chg();

    this.key++;
   
    
  }


  public async zlecenie_selected(obj:any) {

    if (!obj) return;
    if (!obj.indeks_etykiety) return;
    if (!this.idx) return;
    if (!this.idx.indeks_finder) return;
    if (!this.idx.indeks_finder.data) return;

    
    await this.wybierz_indeks_erp_ze_zlecenia(obj.indeks_etykiety)

  }


  public async fill_idx_from_erp() {
    if (!this.idx) return;
    //console.log("fill_idx_from_erp",JSON.stringify(this.idx.indeks_finder))
    if (
      this.idx &&
      this.idx.indeks_finder &&
      this.idx.indeks_finder.data &&
      this.idx.indeks_finder.data.data_indeks_etykiety
    ) {
      const finder_saved = this.idx.indeks_finder;
      const indeks: IIdx | undefined = await new IdxSvc().get_by_wytwor_idm(
        this.idx.indeks_finder.data.data_indeks_etykiety
      );
      if (indeks) {
        if (
          !confirm(
            "Czy przejąć dane z indeksu ERP" +
              this.idx.indeks_finder.data.data_indeks_etykiety +
              "?"
          )
        )
          return;

        this.idx = indeks;
        this.idx.indeks_finder = finder_saved;
        this.idx._id = this.lbl_id;

        await this.chg();
        this.key++;
        alert("Przejęto dane z indeksu - wzoru");
      } else {
        alert(
          "Nie znaleziono indeksu " +
            this.idx.indeks_finder.data.data_indeks_etykiety
        );
        return;
      }
    } else {
      alert("Najpierw wybierz indeks - wzór");
    }
  }

  public async new_indeks() {
    if (!confirm("Czy wyzerować dane?")) return;
    this.idx = new Idx();
    await this.chg();
    alert("Dane indeksu wyczyszczone");
    this.key++;
  }

  public async fill_idx_from_graflow() {
    //if (!confirm("Czy przejąć dane z Graflow?")) return;
    this.idx = new Idx();

    this.idx.link_graflow = "https://dev.e-grafpol.pl"+this.$router.currentRoute.path
    this.idx.lbl_id=this.lbl_id

    if (!this.idx) {
      alert("Indeks nie został stworzony")
      return;
    }

    if (!this.lbl) {
      alert("Brak danych etykiety");
      return;
    }
    if (!this.lbl.colors) {
      alert("Brak danych o kolorach etykiety");
      return;
    }

    if (!this.lbl.tree_id) {
      alert("Przyporządkuj najpierw technologię do etykiety");
      return;
    }
    const tree: ITree | undefined = await new TreeSvc().find_by_id(
      this.lbl.tree_id
    );
    if (!tree) {
      alert("Technologia przyporządkowana do etykiety nie istnieje");
      return;
    }

    if (!this.idx) this.idx = new Idx();
    await IdxImporter.fill_from_tree(this.idx, tree); // idx wypełniony
    await IdxImporter.fill_from_lbl(this.idx, this.lbl);
    await IdxImporter.fill_from_colors(this.idx, this.lbl.colors, true);


    await this.chg();
    if (this.masterData) {
      console.log(this.masterData.formatkowanie_sel);
      console.log(this.idx.formatkowanie);
    }
    console.log(this.idx)
    this.key++;
  }

  public async indeks_selected() {
    console.log("before chg");
    await this.chg();
  }

  async klient_wzor_selected(e: any) {
    if (!this.idx) return;
    console.log("Klient",JSON.stringify(this.idx?.klient_wzor))
    this.idx.nr_klienta_wzor = this.idx?.klient_wzor.data.data_nr_klienta
    this.key_klient_wzor++
  }

  async numer_technologii_selected(e: any) {
    if (!this.idx) return;
    this.key_klient_wzor++
  }

  async create_nowy_w_erp(nr_klienta_wzor:string, technologia:string) {
    if (!nr_klienta_wzor) { alert("Najpierw wybierz numer klienta"); return }
    if (!this.idx) return;

    if (!confirm("Czy utworzyć w ERP indeks NOWY na bazie klienta " + nr_klienta_wzor+"?"))
      return;

    this.idx.rodzaj_zlecenia = "NOWE";
    this.idx.parent_id = this.lbl_id;
    this.idx.nr_klienta_wzor = nr_klienta_wzor;
    this.idx.technologia = technologia

    const ret = await new IdxSvc().create_nowy_w_erp_full(this.idx);
    
    if (ret) {
      if (ret.nr_indeksu) {
        alert("Utworzono w ERP NOWY indeks: " + ret.nr_indeksu);
        this.idx.nr_indeksu = ret.nr_indeksu
        this.idx.nr_indeksu_wzor = "";
        if (this.lbl) {
          this.lbl.nr_indeksu = this.idx.nr_indeksu;
          this.lbl.nr_indeksu_wzor = "";
          this.lbl.version++
          await new LblSvc().update(this.lbl);
          this.$emit("idx_changed", this.idx);
        }
        await this.chg();
        this.key++;
      } else {
        alert("Błąd w zapisie do ERP:"+ ret.uwagi);
      }
    } else alert("Błąd w zapisie do ERP:");
    
  }

  async update_w_erp() {
    if (!this.idx) { alert("Najpierw wybierz indeks"); return;}
    if (!confirm("Czy zapisać zmiany w indeksie ERP " + this.idx.nr_indeksu + "?"))   return;

    //this.idx.rodzaj_zlecenia = "NOWE"
    if (!this.idx?.nr_indeksu) {
      alert("Najpierw zapisz do ERP (NOWY lub KOREKTA).");
      return;
    }
    
    alert("update start")
    const ret = await new IdxSvc().update_w_erp(this.idx);
    //const ret:IIdx=this.idx
    //ret.nr_indeksu = '111111111'

    console.log(ret);
    if (ret) {
      alert("Zapisano do ERP: " + ret.nr_indeksu);
      this.idx.nr_indeksu = ret.nr_indeksu;
      this.idx.nr_indeksu_wzor = ret.nr_indeksu_wzor;
      if (this.lbl) {
        this.lbl.nr_indeksu = this.idx.nr_indeksu;
        this.lbl.nr_indeksu_wzor = this.idx.nr_indeksu_wzor;
        this.lbl.version++
        await new LblSvc().update(this.lbl);
        this.$emit("idx_changed", this.idx);
      }
      await this.chg();
      this.key++;
    } else alert("Błąd w zapisie");
  }

  async create_korekta_w_erp() {
    if (!this.idx) { alert("Problem z idx"); return; }
    if (!confirm("Czy utworzyć w ERP indeks WZNOWIENIE Z KOREKTĄ na bazie " + this.idx.nr_indeksu_wzor + "?") ) return;
    if (!this.lbl) { alert("Problem z przypisanie m etykiety"); return; }
    this.idx.parent_id = this.lbl_id;
    this.idx.rodzaj_zlecenia = "WZNOWIENIE + KOREKTA";
    alert("Tworzenie korekty w ERP")
    const ret = await new IdxSvc().create_korekta_w_erp_full(this.idx);
      if (ret) {
        if (ret.nr_indeksu) {
          alert("Utworzono w ERP indeks jako WZNOWIENIE + KOREKTA: " + ret.nr_indeksu);
          this.idx.nr_indeksu = ret.nr_indeksu;
          this.idx.nr_indeksu_wzor = ret.nr_indeksu_wzor;
          this.$emit("idx_changed", this.idx);
          await this.chg();
          this.key++;
        } else {
          alert("Błąd (1) w zapisie do ERP:"+ ret.uwagi);
        }
      } 
      else alert("Błąd (2) w zapisie do ERP:");

  }

  dbg(idx: any) {
    if (idx._dbg) idx._dbg = 0;
    else idx._dbg = 1;
    this.dbg_key++;
  }
}
